import { Component, OnInit } from '@angular/core';
import { Email } from "./email";
import { EmailService } from "./email.service";

@Component({
  selector: 'app-configuracoes',
  templateUrl: './configuracoes.component.html',
  styleUrls: ['./configuracoes.component.css'],
  providers: [EmailService]
})
export class ConfiguracoesComponent implements OnInit {

  emails: Email[];
  emailsDepto: { [chave: number]: string } = {};
  emailsDigitados: Email;

  constructor(private emailService: EmailService) { }

  getEmails(): void {
    //console.log('obtendo emails..');
    this.emailService.getEmailsDeptoPsicologico().then(resposta => {
      //console.log(resposta);
      this.emails = resposta;
      for (var ch in resposta) {
        //console.log(resposta[ch].id);
        this.emailsDepto[resposta[ch].id] = resposta[ch].email;
        //console.log(resposta[ch].perfil);
      }
    });
  }

  public salvar(): void {
    this.emailsDigitados = new Email;
    //console.log(this.emailsDepto);

    let dados: { [chave: number]: string } = {};
    for (var ch in this.emailsDepto) {
      //console.log(ch);
      //console.log(this.emailsDepto[ch]);
      dados[ch] = this.emailsDepto[ch];
    }

    this.emailsDigitados.lista = dados; // lista de emails digitados no formato {id:email}
    //console.log(this.emailsDigitados);

    this.emailService.salvarEmails(this.emailsDigitados)
        .then((resposta) => {alert(resposta);})

  }

  ngOnInit() {
    this.getEmails();
  }

}



// WEBPACK FOOTER //
// ./src/app/configuracoes/configuracoes.component.ts